
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logo-small': {
    width: 587,
    height: 816,
    viewBox: '0 0 587 816',
    data: '<path pid="0" d="M567 816H20c-11 0-20-9-20-20V20C0 9 9 0 20 0h547c11 0 20 9 20 20v776c0 11-9 20-20 20zM40 776h507V40H40v736z" _fill="#f03"/><path pid="1" d="M433 565c-11 0-20-9-20-20V320L307.7 426.2c-3.8 3.8-8.9 5.9-14.2 5.9-5.3 0-10.4-2.1-14.2-5.9L174 320v225c0 11-9 20-20 20s-20-9-20-20V271.5c0-8.1 4.9-15.4 12.4-18.5 7.5-3.1 16.1-1.3 21.8 4.4l125.3 126.3 125.3-126.3c5.7-5.8 14.3-7.5 21.8-4.4 7.5 3.1 12.4 10.4 12.4 18.5V545c0 11-9 20-20 20z" _fill="#f03"/>'
  }
})
